import { Currency } from '@aboutyou/legacy-shared/src/utils/currency'
import { TrackingWishlistItem } from '@aboutyou/legacy-tracking-sdk'
import { mapProductToTracking } from 'helpers/tracking/helpers'
import Product from 'store/entities/Product/Product.store'
import { LocaleType } from 'types/locale'

export const dummyElementContext = {
  columnIndexInSection: 0,
  elementIndexInSection: 0,
  rowIndexInSection: 0,
  type: 'element-context',
} as const

export const getTrackingWishlistItem = ({
  product,
  currency,
}: {
  product: Product
  locale: LocaleType
  currency: Currency
}): TrackingWishlistItem => {
  const trackingProduct = mapProductToTracking(product, currency.iso)

  const additionalWishlistData = undefined

  return {
    key: 'wishlist',
    product: trackingProduct,
    additionalWishlistData,
  }
}
